export default "__VITE_ASSET__Cgfn8MQf__"